import ButtonActionIcon from "../../../components/BuilderComponents/ButtonActionIcon";
import CopyToClipboard from "../../../components/BuilderComponents/CopyToClipboard";
import MaterialIcon from "../../../components/BuilderComponents/MaterialIcon";
import { getToolTipAttributes } from "../../../utils/tooltip";
import "../monitor.css";

const getStatusIcon = (durationMs, rawDetails) => {
  if (durationMs > 15000) {
    const durationSec = (durationMs / 1000).toFixed(2);
    return (
      <MaterialIcon
        {...getToolTipAttributes(`Slow Response (${durationSec}s)`)}
        name="cancel"
        style={{ color: "#d32f2f", fontSize: "22px" }}
        title={`Slow Response (${durationSec}s)`}
        decorative={false}
      />
    );
  }

  const statusMatch = rawDetails.match(/Status:\s*(\d+)/);
  if (statusMatch) {
    const statusCode = parseInt(statusMatch[1], 10);

    if (statusCode >= 400) {
      return (
        <MaterialIcon
          {...getToolTipAttributes(`Error: ${statusCode}`)}
          name="error"
          style={{ color: "#d32f2f", fontSize: "22px" }}
          title={`Error: ${statusCode}`}
          decorative={false}
        />
      );
    } else {
      return (
        <MaterialIcon
          {...getToolTipAttributes(`Success: ${statusCode}`)}
          name="check_circle"
          style={{ color: "#2e7d32", fontSize: "22px" }}
          title={`Success: ${statusCode}`}
          decorative={false}
        />
      );
    }
  }

  return (
    <MaterialIcon
      {...getToolTipAttributes("Success")}
      name="check_circle"
      style={{ color: "#2e7d32", fontSize: "22px" }}
      title="Success"
      decorative={false}
    />
  );
};

const LogRow = ({ log, onViewDetails }) => {
  const appName = log.app_name || "N/A";
  const displayDetails = log.summary_details || "N/A";
  const rawDuration = log.duration || 0;

  let durationDisplay = "-";
  let durationMs = 0;

  durationMs = parseFloat(rawDuration);

  if (!isNaN(durationMs) && durationMs > 0) {
    const durationSeconds = durationMs / 1000;
    durationDisplay = `${durationSeconds.toFixed(2)}s`;
  }

  return (
    <tr>
      <td>
        <div style={{ display: "flex", alignItems: "center", gap: "5px" }}>
          <span
            style={{
              maxWidth: "200px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap"
            }}
            title={appName}
          >
            {appName}
          </span>
          {log.app_id && <CopyToClipboard text={log.app_id} successMessage="App ID" />}
        </div>
      </td>

      <td>{getStatusIcon(durationMs, displayDetails)}</td>

      <td>
        <span className={`status_pill ${log.type || "default"}`}>{log.type || "N/A"}</span>
      </td>

      <td>
        <span
          style={{
            maxWidth: "250px",
            display: "block",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            fontSize: "12px"
          }}
          title={displayDetails}
        >
          {displayDetails}
        </span>
      </td>

      <td>
        <span
          style={{
            fontSize: "12px",
            fontFamily: "monospace",
            color: durationMs > 15000 ? "#d32f2f" : "#555",
            fontWeight: durationMs > 15000 ? "600" : "400"
          }}
        >
          {durationDisplay}
        </span>
      </td>

      <td>{log.user_email || "-"}</td>

      <td>
        {log.created_at
          ? new Date(log.created_at).toLocaleString("en-IN", {
              year: "numeric",
              month: "2-digit",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit",
              second: "2-digit",
              hour12: true
            })
          : "-"}
      </td>

      <td>
        <ButtonActionIcon onClick={() => onViewDetails(log)} type="open_in_new" />
      </td>
    </tr>
  );
};

export default LogRow;
